<template>
    <Admin
        :title="__('Coupons', null, $page.props.profile_locale)"
    >
    <div class="grid xl:grid-cols-4 lg:grid-cols-3 grid-cols-2 xs gap-3">
        <div
            class="shadow-md rounded-md overflow-hidden relative group"
            :class="[
                item.used || isAfterDate(item.to) ? 'bg-gray-200' : ''
            ]"
            v-for="(item, key) in coupons.data" :key="key"
        >
            <!-- <div
                v-if="item.used || isAfterDate(item.to)"
                class="absolute z-20 bg-gray-900 bg-opacity-20 inset-0 opacity-100 transition duration-300 flex items-center justify-center"
            >
                <h1 class="rounded-md px-1 bg-gray-300 text-red-700 font-bold text-xl">{{__('Coupon inactive', null, $page.props.profile_locale)}}</h1>
            </div> -->
            <div>
                <h2 class="bg-gray-900 text-gray-200 px-1 py-2 font-bold flex justify-between items-center">
                    <span>{{ item.name }}</span>
                    <span class="bg-red-700 rounded-md px-1">
                        {{ getDiscount(item) }}
                    </span>
                </h2>
                <h1
                    v-if="item.used || isAfterDate(item.to)"
                    class="px-2 pt-2 text-red-700 font-bold"
                >{{__('Coupon inactive', null, $page.props.profile_locale)}}</h1>
                <h2 class="p-2 pb-0 font-bold">{{ item.code }}</h2>
                <h2 class="px-2"><span class="font-bold">{{__('Type of coupon', null, $page.props.profile_locale)}}: </span>{{ item.type }}</h2>
                <h2 class="px-2"><span class="font-bold">{{__('Type of discount', null, $page.props.profile_locale)}}: </span>{{ item.discount_type }}</h2>
                <h2 class="px-2 text-xs text-gray-400 font-bold" v-if="item.from">{{ 'From: ' + item.from }}</h2>
                <h2 class="px-2 text-xs text-gray-400 font-bold" v-if="item.to">{{ 'To: ' + item.to + ' ('+ getDateEndOf(item.to) +')' }}</h2>
            </div>
            <div class="flex my-2">
                <IconLink
                    class="mx-1 p-1"
                    icon="pencil"
                    :size="30"
                    :href="route('dashboard.admin.coupon.edit', item.id)"
                />
                <IconLink
                    class="mx-1 p-1"
                    icon="trash"
                    color="red"
                    :size="30"
                    href="#"
                    @click.prevent="remove(item)"
                />
            </div>

        </div>
        <InertiaLink
            class="bg-gray-400 bg-opacity-10 rounded-md text-gray-400 p-5 flex items-center justify-center hover:bg-gray-900 hover:bg-opacity-10 transition duration-300 hover:shadow-md"
            :href="route('dashboard.admin.coupon.create')"
        >
            <SvgIcon
                name="plus"
                class="w-1/2 h-1/2"
            />
        </InertiaLink>

    </div>
    <PaginateLink
        class="mt-5"
        :links="coupons.links"
    />
    <div class="grid xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 gap-3 pt-5 mt-5 border-t border-gray-200">
        <div class="shadow-md rounded-md overflow-hidden relative group">
            <div>
                <h2 class="bg-gray-900 text-gray-200 px-1 py-2 font-bold flex justify-between items-center">
                    <span>{{ firstTransaction.name }}</span>
                    <span class="bg-red-700 rounded-md px-1">
                        {{ getDiscount(firstTransaction) }}
                    </span>
                </h2>
                <h2 class="p-2 pb-0 font-bold">{{ firstTransaction.code }}</h2>
                <h2 class="px-2"><span class="font-bold">{{__('Type of coupon', null, $page.props.profile_locale)}}: </span>{{ firstTransaction.type }}</h2>
                <h2 class="px-2"><span class="font-bold">{{__('Type of discount', null, $page.props.profile_locale)}}: </span>{{ firstTransaction.discount_type }}</h2>
            </div>
            <div class="flex my-2">
                <IconLink
                    class="mx-1 p-1"
                    icon="pencil"
                    :size="30"
                    :href="route('dashboard.admin.coupon.edit', firstTransaction.id)"
                />
            </div>
        </div>
    </div>
    </Admin>
</template>

<script>
    import Admin from '@/Layouts/Admin';
    import IconLink from 'UI/IconLink';
    import SvgIcon from 'UI/SvgIcon';
    import PaginateLink from 'UI/PaginateLink';

    import {
        getDiscount,
        getDateEndOf,
        isAfterDate,
    } from 'helper';
    import { Inertia } from '@inertiajs/inertia';

    export default {
        props: {
            coupons: [Object, Array],
            firstTransaction: [Object, Array],
        },
        components: {
            Admin, IconLink, SvgIcon, PaginateLink
        },

        setup(props) {
            function remove(ev){
                if(confirm(app.__("Are you sure you want to delete?"))){
                    Inertia.visit(route('admin.coupon.remove', ev.id), { method: 'post' });
                }
            }


            return {
                remove,

                getDiscount,
                getDateEndOf,
                isAfterDate,
            }
        }
    }
</script>
